export const changeMain_by = {
    load: 'Абнаўленне',
    positiveResponse: 'Дадзеныя вашага профілю паспяхова зменены',
    positiveResponsePassword: 'Ваш пароль паспяхова зменены',
    yourNewPassword: 'Новы пароль:',
    negativeResponse: 'Нешта пайшло не так',
    repeatRequest: 'Хутчэй за ўсё змены ў вашых дадзеных ужо захаваны',
    linkMainPage: 'Галоўная старонка',
}